import { render } from "./CmpCarousel.vue?vue&type=template&id=641a3166&ts=true"
import script from "./CmpCarousel.vue?vue&type=script&lang=ts"
export * from "./CmpCarousel.vue?vue&type=script&lang=ts"

import "./CmpCarousel.vue?vue&type=style&index=0&id=641a3166&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__